// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB-AAe8yv9SjDI1zbwP1m7pIKWwEodDWS0",
  authDomain: "kactuskwenchers-d9203.firebaseapp.com",
  projectId: "kactuskwenchers-d9203",
  storageBucket: "kactuskwenchers-d9203.firebasestorage.app",
  messagingSenderId: "257768592249",
  appId: "1:257768592249:web:065ba7541a617538ded5a8",
  measurementId: "G-HG2Z45XNLL"
};



const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
